// import './footer.css';

export default class Footer {
  constructor( element ) {
    element.classList.add('javascript');
  }
}
